// extracted by mini-css-extract-plugin
module.exports = {"box":"BottomNavigation_box_1Hi5N","list":"BottomNavigation_list_27THw","choose":"BottomNavigation_choose_3c_Uv","unread-number":"BottomNavigation_unread-number_Djynv"};